var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExcel = function SvgExcel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63 -52.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15092.675-14648.912v-50.016h26.284l12.139,12.138v37.878Z",
    transform: "translate(15169.273 14755.998)",
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15034.745-14698.928v12.043h11.9",
    transform: "translate(15137.665 14755.998)",
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66 73.893)",
    fill: "#9d9c9e",
    stroke: "#9d9c9e",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.697,
    height: 24.372,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22.697,
    height: 22.372,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-15103.231-14635.783h3.53l3.393-6.55,3.49,6.55h3.264l-4.943-7.75,4.691-7.6h-2.88l-3.482,6.3-3.219-6.3h-3.3l4.569,7.6Z",
    transform: "translate(15174.578 14729.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.49 76.921)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    transform: "translate(10.451)",
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.49 81.465)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    transform: "translate(10.451)",
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.49 86.009)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    transform: "translate(10.451)",
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.49 90.553)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    transform: "translate(10.451)",
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.49 95.096)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 6.816,
    transform: "translate(10.451)",
    fill: "none",
    stroke: "#9d9c9e",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "excel.37b1387ad216f87627e86b9910f16395.svg";